import { EmotionPerfTest } from '@grafana/ui/src/components/ThemeDemos/EmotionPerfTest';

export const BenchmarksPage = () => {
  return <EmotionPerfTest />;
};

export default BenchmarksPage;
